import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6b19b41d&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JG\\jg\\IWMS5.0\\SRM\\GIT\\SRM.VUE\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b19b41d')) {
      api.createRecord('6b19b41d', component.options)
    } else {
      api.reload('6b19b41d', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=6b19b41d&", function () {
      api.rerender('6b19b41d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/DeliveryNote/Outsourced/index.vue"
export default component.exports